<app-lista-escolas></app-lista-escolas>
<section *ngIf="true" id="secretaria" class="wow fadeIn py-5">
   <div class="container">
    <header class="section-header text-center mb-4 wow animate__animated animate__fadeInDown">
      <h3 class="section-title">Mensagem da Secretária</h3>
    </header>

    <div class="row align-items-center justify-content-center secretaria-box">
      <!-- Imagem -->
      <div class="col-lg-5 col-md-6 text-center mb-4 mb-lg-0 wow animate__animated animate__fadeInLeft" data-wow-delay="0.2s">
        <img src="/assets/img/lilian.png" alt="Lilian Braga Vieira" class="img-fluid profile-img" />
      </div>

      <!-- Texto -->
      <div class="col-lg-7 col-md-12 wow animate__animated animate__fadeInRight" data-wow-delay="0.4s">
        <h4 class="mb-2 nome-secretaria">LILIAN BRAGA VIEIRA</h4>
        <p class="cargo-secretaria">Secretária de Educação</p>
        <p class="descricao-secretaria">
          Possuindo larga formação e experiência na área de educação,<br />
          Lilian é formada pelo CEFAM (Centro Específico de Formação e Aperfeiçoamento do Magistério),<br />
          além de também Geógrafa, Pedagoga e pós-graduada em Psicologia Educacional.<br />
          Iniciou sua carreira como professora de ensino infantil e fundamental na rede municipal de Itapevi,<br />
          onde também atuou como professora na rede estadual do ensino médio,<br />
          coordenadora pedagógica, diretora de escola, supervisora de ensino e culminando como Secretária de Educação de Itapevi.<br />
          Posteriormente foi também professora e tutora na Universidade Uniararas. No município de Carapicuíba continuou sua carreira como diretora pedagógica,<br />
          Secretária de Educação e Secretária Adjunta de Administração.
        </p>
      </div>
    </div>
  </div>
</section>

<section id="services" class="py-5">
  <div class="container">

    <header class="section-header text-center mb-5 wow animate__animated animate__fadeInUp">
      <h3>Nossos Pilares</h3>
      <h4 class="text-p">A finalidade da Secretaria da Educação</h4>
      <p class="text-justify text-m">
        A Secretaria de Educação de Mairiporã tem a atribuição de planejar e
        executar as ações educacionais no âmbito do Sistema Municipal de Ensino,
        por meio da promoção de políticas públicas de democratização, acesso,
        permanência e sucesso do aluno ao ensino público gratuito e de qualidade
        nos níveis da Educação Infantil, Ensino Fundamental, nas modalidades de
        Educação Especial e Educação de Jovens e Adultos.
      </p>
    </header>

    <div class="row text-center">
      
      <!-- Card 1 -->
      <div class="col-lg-4 col-md-6 mb-4">
        <div class="pillar-card">
          <div class="icon"><i class="fas fa-heart"></i></div>
          <h4 class="title">Valores</h4>
          <p class="description">
            Ética, Transparência, Efetividade, Afetividade, Equidade, Respeito, Justiça, Excelência, Disposição de servir.
          </p>
        </div>
      </div>

      <!-- Card 2 -->
      <div class="col-lg-4 col-md-6 mb-4">
        <div class="pillar-card">
          <div class="icon"><i class="fas fa-bullseye"></i></div>
          <h4 class="title">Missão</h4>
          <p class="description">
            Preparar os educandos para a cidadania; valorizar profissionais; integrar escola, família e comunidade.
          </p>
        </div>
      </div>

      <!-- Card 3 -->
      <div class="col-lg-4 col-md-6 mb-4">
        <div class="pillar-card">
          <div class="icon"><i class="fas fa-eye"></i></div>
          <h4 class="title">Visão</h4>
          <p class="description">
            Ser uma gestão com excelência, transparência e compromisso, voltada à formação cidadã dos alunos.
          </p>
        </div>
      </div>

    </div>
  </div>


   